import React from 'react';
import '../style/photos.css';

// Miniature optimisée Cloudinary (format + qualité auto) pour la grille.
function thumbUrl(url) {
  if (url && url.includes('/upload/')) {
    return url.replace('/upload/', '/upload/f_auto,q_auto,w_800/');
  }
  return url;
}

function spanClass(photo, index) {
  if (index === 0) return 'bb-gallery__item--big';
  const ar = photo.width && photo.height ? photo.width / photo.height : 1;
  if (ar > 1.3) return 'bb-gallery__item--wide';
  if (ar < 0.8) return 'bb-gallery__item--tall';
  return '';
}

function PhotoGrid({ photos, onSelect }) {
  if (!photos.length) {
    return <p className="bb-category__empty">Aucune photo pour l'instant.</p>;
  }
  return (
    <div className="bb-gallery">
      {photos.map((photo, i) => (
        <button
          type="button"
          className={`bb-gallery__item ${spanClass(photo, i)}`}
          key={photo.id || i}
          onClick={() => onSelect(photo)}
          aria-label={photo.title || photo.description || 'Voir la photo'}
        >
          <img src={thumbUrl(photo.url)} alt={photo.title || photo.description || 'Photo'} loading="lazy" />
          {photo.title && <span className="bb-gallery__cap bb-display">{photo.title}</span>}
        </button>
      ))}
    </div>
  );
}

export default PhotoGrid;
